import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, forkJoin, mergeMap, Subject, switchMap, takeUntil, throwError } from 'rxjs';
import { AppStateService } from 'src/app/core-module/services/app-state.service';

import { environment } from 'src/environments/environment';
import { DeviceConfigStateService } from "../../../core-module/services/state/device-config-state.service";
import { FeatureUtilsService } from "../../../core-module/services/state/feature-utils.service";
import { MultiOneHttpClient } from "../../../core-module/services/state/multi-one-http-client.service";
import { UiSignalsStateService } from "../../../core-module/services/state/ui-signals-state.service";@Component({
  standalone: false,
  selector: 'app-read-device-selection-popup',
  templateUrl: './read-device-selection-popup.component.html',
  styleUrls: ['./read-device-selection-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReadDeviceSelectionPopupComponent implements OnInit, OnDestroy {

  @Input() public readerName;
  @Input() public clickEvent;
  @Input() public componentFrom;
  nameR: LegacyAny = [];
  selectedReader: LegacyAny = 1;
  firsOption: LegacyAny;
  readreDataUrl = '/device/v1/NFC/LCN9600/dummy/memorybank/114';
  sendReaderInfo;
  readerDevicesForm: FormGroup;
  readersInfo: Array<LegacyAny>;
  reader = "dali";
  readerConnected: boolean = false
  readerBaseUrl: string;
  isDcsConnected: boolean = true;
  readerListUrl = "/peripheral/v1/types";
  readingStatus;
  readerData;
  isDaliSupported: boolean = false;
  pathVal: string;
  unsubscribe = new Subject<void>();
  statusCallDataSwVersion:LegacyAny;
  statusCallData;
  latestDcsVersion: LegacyAny;
  isReadDevice: boolean = false;
  constructor(
    public activemodal: NgbActiveModal, private fb: FormBuilder,
private appState: AppStateService,
    private uiSignals: UiSignalsStateService,
    private utils: FeatureUtilsService,
    private deviceConfig: DeviceConfigStateService,
    private httpClient: MultiOneHttpClient
  ) { }

  ngOnInit() {
    // setTimeout(() => {
    //   // this.nameR = this.readerName;
    //   // this.slectedReader = this.nameR[0];
    // }, 1000);



    this.pathVal = this.utils.getImageUrl(window.location.hostname);
    this.readerDevicesForm = this.fb.group({
      readerType: new FormControl(""),
      simpleSetDevices: new FormControl(""),
      daliDevices: new FormControl(""),
    });
    this.getReaders();
    this.refreshReadersList();
  }
  //
  // getReaders() {
  //   if (localStorage.getItem("readerDevices") &&
  //     localStorage.getItem("readerDevices") != 'undefined') {
  //     this.readersInfo = JSON.parse(
  //       localStorage.getItem("readerDevices")
  //     );
  //     if (localStorage.getItem("detectedReaderInfo") &&
  //       localStorage.getItem("detectedReaderInfo") != 'undefined') {
  //
  //       let reader = JSON.parse(
  //         localStorage.getItem("detectedReaderInfo")
  //       );
  //
  //       this.readerDevicesForm.controls.readerType.setValue('simpleSet');
  //       this.readerDevicesForm.controls.simpleSetDevices.setValue(reader.selectedReader.peripheralType+'-'+reader.selectedReader.peripheralId);
  //       this.readerConnected = reader.readerConnected;
  //     } else {
  //     }
  //   } else {
  //     this.readersInfo = [];
  //     this.readerConnected = false;
  //     this.readerDevicesForm.controls.readerType.setValue('simpleSet');
  //     this.readerDevicesForm.controls.simpleSetDevices.setValue('select');
  //
  //   }
  //   this.readerDevicesForm.controls.daliDevices.setValue('select');
  //
  // }



  // TypeScript
  getReaders() {
    // const hostname = window.location.hostname;
    // const isLocalOrStaging = hostname.includes('www.multione.signify.com') || hostname.includes('staging');
    let readers = [];
// remove this once box configuration is enabled
    if (this.appState.getReaderDevices() && this.appState.getReaderDevices() !== 'undefined') {
      readers = this.appState.getReaderDevices();
      // Filter out LCN9640 if on localhost or staging
      // if (isLocalOrStaging) {
      //   readers = readers.filter((r: LegacyAny) => r.peripheralType !== 'LCN9640');
      // }
      this.readersInfo = readers;

      if (this.appState.getDetectedReaderInfo() && this.appState.getDetectedReaderInfo() !== 'undefined') {
        const reader = this.appState.getDetectedReaderInfo();
        this.readerDevicesForm.controls.readerType.setValue('simpleSet');
        this.readerDevicesForm.controls.simpleSetDevices.setValue(reader.selectedReader?.peripheralType + '-' + reader.selectedReader?.peripheralId);
        this.readerConnected = reader.readerConnected;
      }
    } else {
      this.readersInfo = [];
      this.readerConnected = false;
      this.readerDevicesForm.controls.readerType.setValue('simpleSet');
      this.readerDevicesForm.controls.simpleSetDevices.setValue('select');
    }
    this.readerDevicesForm.controls.daliDevices.setValue('select');
  }

  refreshReadersList() {
    this.readerBaseUrl = environment.multiOneAPIBaseReadUrl;

          const status = this.getDeviceReader();
          const readerSelection = this.getReaderList();

          status.pipe(
            mergeMap(data => {
              this.statusCallData = data;
              this.statusCallDataSwVersion =
              this.statusCallData.serverSwVersion
                .toString()
                .split(".")
                .join("");
            this.latestDcsVersion = this.appState.getLatestDcsVersion();

            this.appState.setStatusCallDataSwVersion(this.statusCallDataSwVersion);


            if (
              this.latestDcsVersion != null &&
              this.statusCallDataSwVersion != null
            ) {
              if (
                parseInt(this.latestDcsVersion) >
                parseInt(this.statusCallDataSwVersion)
              ) {
                this.isReadDevice = false;
              } else {
                this.isReadDevice = true;
              }
              this.deviceConfig.sendReadDevice(this.isReadDevice);
            }
              return readerSelection.pipe(
                catchError(err => {
                  // do stuff with err from API1 request
                  return throwError(() => err);
                })
              )
            }),
            catchError(err => {
              this.deviceConfig.setReadDeviceStatusViaSimpleSet(false);
              return throwError(() => err);

            })


          ).subscribe(results => {
              const readerData = results;
              this.appState.setReaderDevices(readerData);

              const detectedReader = {
                readerType: 'SimpleSet',
                selectedReader: readerData[this.selectedReader -1 ],
                readerConnected: true,
                isDcsConnected: true
              }

              this.appState.setDetectedReaderInfo(detectedReader);
              this.deviceConfig.setReadDeviceStatusViaSimpleSet(true);
              this.getReaders();

            },
            error => {
              this.appState.setReaderDevices(null);
              const targetUrl = error?.target?.url ?? error?.error?.target?.url ?? error?.url;
              if (targetUrl === "http://localhost:2020/server/v1/status") {
                this.isDcsConnected = false;
                this.appState.setStatusCallDataSwVersion('0');
              } else {
                this.isDcsConnected = true;
              }
              const detectedReader = {
                readerType: 'SimpleSet',
                selectedReader: null,
                readerConnected: false,
                isDcsConnected: this.isDcsConnected
              }

              this.appState.setDetectedReaderInfo(detectedReader);

              this.getReaders();

            }
          )
      //   }
      // });
  }

  getDeviceReader() {
    return this.httpClient.getServerStatus(this.readerBaseUrl);
  }

  getReaderList() {
    return this.httpClient.apiCall("get", this.readerBaseUrl + this.readerListUrl);
  }

  onChange(value) {
    this.selectedReader = value;
  }

  selectreader() {



    if (this.readersInfo.length > 0) {
      const reader = this.appState.getDetectedReaderInfo();

      let selevtedReadArr:LegacyAny[] = [];
       selevtedReadArr=this.readersInfo.filter((item)=>{
       return item['peripheralType']+'-'+item['peripheralId']===this.readerDevicesForm.controls['simpleSetDevices'].value
      })

      reader['selectedReader'] = selevtedReadArr[0];
      this.appState.setDetectedReaderInfo(reader);
      this.appState.setReaderInfo(selevtedReadArr);
      if (!this.clickEvent) {
        this.uiSignals.readerInfo(selevtedReadArr[0]);
      }

    }

    this.activemodal.close();

  }

  cancel() {
    this.activemodal.close();

  if (this.componentFrom==="ReadDevice") {
    this.uiSignals.modalClose('close');
  }

   //
  }

  ngOnDestroy() {
    this.uiSignals.modalClose('');
  }



}

